import type { AdMedia } from "src/pages/ad-studio/insights/performance/types";

/** Which creative workflow an ad's medium asks the generation agent for. */
export type AdMedium = "video" | "static";

export type AdFormat = "image" | "video";

export const formatOf = (media: AdMedia): AdFormat | "no-media" => {
  switch (media.kind) {
    case "no-media": {
      return "no-media";
    }
    case "media": {
      const [{ item }] = media.creatives;
      return item.kind;
    }
    default: {
      return media satisfies never;
    }
  }
};
